import Link from "next/link";

import {
  FAQS,
  DISCLAIMER,
  AnalyticsHeader,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION_ADD_ON,
  REGISTER_TERMS_AND_CONDITIONS,
} from "./helper";
import { routes } from "src/shared/routes";

import mobileBanner from "public/images/miamiopen_upgrades/Mobile 2x.png";
import desktopBanner from "public/images/miamiopen_upgrades/DESKTOP 2x.png";
import footerLogo from "public/images/miamiopen_upgrades/Logo_MO_Solid_VER_Black_RGB.png";
import gradientLogo from "public/images/miamiopen_upgrades/miamiopen_upgrades_logo_gradient.jpg";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const miamiopen_upgrades: TTeamConfig = {
  TEAM_SCHEMA: "miamiopen_upgrades",
  TEAM_FULL_NAME: "Miami Open",
  BROWSER_TITLE: "Miami Open Upgrades",
  CLIENT_ID: "0abc999552b7.seasonshare.miamiopen-proplay.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#F8A11A",
    COLORS_SECONDARY: "#ffffff",
    LOGOUT_ON_INVALID_SESSION: false,
    IS_INTERCOM_ENABLED: true,
    DEFAULT_APP_ROUTE: routes.landing,
    ANALYTICS_HEADER: AnalyticsHeader,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_UPCOMING_EVENTS: false,
      HIDE_MANAGE_SUBSCRIPTION: true,
      HIDE_FAQS: true,
    },

    FOOTER: {
      BACKGROUND_COLOR: "#F8A11A",
      COPYRIGHT_TEXT: `© ${new Date().getFullYear()}`,
    },

    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/miamiopen",
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,
    IS_CROWD_HANDLER_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      HIDE_SECTION_TITLE: true,
    },

    HIDE_PASSES: true,
    PASS_BANNER: {
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
    SHOW_ALL_PASSES_UNDER_BANNER: true,

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: false,
      ATTEND_BUTTON_COLOR: "#F8A11A",
    },

    DEFAULT_PAGE_TOP_NOTIFICATION: {
      BACKGROUND_COLOR: "#000000",
    },

    HIDE_EVENT_BANNER: true,

    PAGE_TITLE: "Available Offers",
    HIDE_ALL_GAMES_BUTTON: true,

    ADD_ON: {
      CUSTOM_MAX_SEAT_CLAIMED_MESSAGE: "This offer is no longer available.",
      ADD_ON_PURCHASE_SUCCESS_MESSAGE: {
        TITLE: () => "Purchase Confirmed!",
        DESCRIPTION: () => (
          <>
            Thank you for your purchase! Login{" "}
            <Link
              href="https://am.ticketmaster.com/miamiopen"
              target="_blank"
              style={{
                color: "#F8A11A",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              here
            </Link>{" "}
            to view your tickets.
          </>
        ),
      },
    },

    DISCLAIMER: <DISCLAIMER />,
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTER_TERMS_AND_CONDITIONS />,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },
  },

  IMAGES: {
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/Miami%20Open/Stadium.png",
    LANDING_PAGE_STATIC_BANNER_URL: desktopBanner.src,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: mobileBanner.src,
    LOGO_URL: gradientLogo.src + `?width=128&height=69`,
    FOOTER_LOGO_URL: footerLogo.src + `?width=180&height=106`,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION_ADD_ON,
    NAV_MENU: {
      UPCOMING_EVENTS: "Available Offers",
    },
  },
};
